module.exports = __webpack_public_path__ + "static/media/accepted.8dfe7c91.svg";